import Text from '@shared/components/content/text';
import { Button } from '@shared/components/ui/button';
import { generatePath, useNavigate } from 'react-router-dom';
import { ReportType } from '../types';
import { getReportsPathMap } from '../utils';

interface ReportFallbackProps {
  reportType: ReportType;
  resultError?: { type: string; message: string };
  reportUuid: string;
}

export function ReportFallback({
  reportType,
  resultError,
  reportUuid,
}: ReportFallbackProps) {
  const navigate = useNavigate();
  const reportPaths = getReportsPathMap()[reportType];

  return (
    <div className="my-auto flex h-screen flex-col items-center justify-center space-y-4">
      <Text>
        {resultError?.type === 'report-result-not-found'
          ? resultError?.message
          : 'Error getting results for this report'}
      </Text>
      <Button
        onClick={() =>
          resultError?.type === 'report-result-not-found'
            ? navigate(
                generatePath(reportPaths.report, { report_uuid: reportUuid })
              )
            : navigate(reportPaths.list)
        }
      >
        Go back to report
      </Button>
    </div>
  );
}
